import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.custom-error', {
        url: '/custom_error?error_message',
        component: 'customError',
        resolve: {errorMessage},
    });
}

/** @ngInject */
function errorMessage($stateParams) {
    return $stateParams.error_message;
}



// WEBPACK FOOTER //
// ./src/portal/states/public/custom-error/custom-error.state.js